export default __webpack_public_path__ + "static/image6-0086b0bf2e415d7a873e9664ff911f7f.gif";